import { mapGetters, mapActions } from 'vuex'
import RegulationModule, { MODULE_NAME } from './index'

const RegulationMixin = {
  namespaced: RegulationModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(RegulationModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(RegulationModule.actions)) }
}

export default RegulationMixin



// WEBPACK FOOTER //
// ./src/store/module/regulation/mixin.js